import React, { FC } from 'react';
import {
  isUrlInternal,
  buildUrlWithParameters,
  getSourceFromUrlParameters,
} from '../utils/url-utils/urlUtils';

function getTarget(url = '', target?: string) {
  if (!url) {
    return undefined;
  }
  if (target) {
    return target;
  }
  const urlInternal = isUrlInternal(url);
  if (!urlInternal) {
    return '_blank';
  }
}

function getRel(target?: string, rel?: string) {
  if (target === '_blank' && rel) {
    return `noopener noreferrer ${rel}`;
  }
  if (target === '_blank' && !rel) {
    return 'noopener noreferrer';
  }
  if (rel) {
    return rel;
  }
  return '';
}

type Props = React.HTMLProps<HTMLAnchorElement> & {
  source?: string;
};

const defaultProps = {
  target: '',
  href: undefined,
  rel: '',
  source: '',
};

export const Hyperlink: FC<Props> = (props) => {
  const addSourceAndExecuteOnClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    const { source, onClick = () => {} } = props;
    if (source && event) {
      const url = event.currentTarget.href;
      if (!getSourceFromUrlParameters(url)) {
        event.currentTarget.href = buildUrlWithParameters(url, { source }); // eslint-disable-line no-param-reassign
      }
    }
    onClick(event);
  };

  const target = getTarget(props.href, props.target);
  const rel = getRel(target, props.rel);
  const attributes = {
    target,
    rel,
  };
  return <a {...props} {...attributes} onClick={addSourceAndExecuteOnClick} />; // eslint-disable-line jsx-a11y/anchor-has-content
};

Hyperlink.defaultProps = defaultProps;
